import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';

// Import helrpes
import { agreementsTabs } from './helpers/index';

const AgreementsTabs = () => <Tabs tabs={agreementsTabs} />;

export default AgreementsTabs;
